import AppConstants from '../constants/AppConstants';
import {getTotalPages} from "./helper";

export const initialState = {
    totalItems: 0,
    totalPages: 0,
    loading: false
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case AppConstants.CONVERSION_GET_TOTAL_LOADING:
            return {
                ...state,
                loading: true
            };

        case AppConstants.CONVERSION_GET_TOTAL_SUCCESS:
            return {
                ...state,
                loading: false,
                totalItems: action.items.total,
                totalPages: getTotalPages(parseInt(action.items.total), action.items.count),
            };

        default:
            return state;
    }
};
